import React from "react";
import {
	MetreaDialogBackdrop,
	MetreaDialogContent,
	MetreaDialogRoot,
} from "@metrea-ui/v2";

/**
 * Shared direct-v2 modal wrapper that preserves the current RAVEN dialog
 * contract while keeping the implementation on Metrea UI primitives only.
 */
export const AppModal = React.forwardRef((props, ref) => {
	const { open, onClose, children, className, style, ...rest } = props;

	const resolvedOnClose = onClose || (() => {});

	const backdropStyle = {
		backgroundColor: "rgba(0,0,0,0.5)",
		zIndex: 1300,
	};

	const contentStyle = {
		background: "#fff",
		color: "inherit",
		zIndex: 1400,
		outline: "none",
		...(style || {}),
	};

	const handleOpenChange = (next) => {
		const isNowOpen = typeof next === "boolean" ? next : next?.open ?? next?.target?.open ?? !!next;
		if (!isNowOpen) resolvedOnClose();
	};

	return (
		<MetreaDialogRoot
			open={open}
			onOpenChange={handleOpenChange}
			// RAVEN mounts these dialogs already open. Skip the initial presence
			// animation so modal shells render centered immediately instead of
			// appearing to travel from the top on first paint.
			skipAnimationOnMount
			placement="center"
			motionPreset="none"
			{...rest}
		>
			<MetreaDialogBackdrop style={backdropStyle} />
			<MetreaDialogContent backdrop={false} ref={ref} className={className} style={contentStyle}>
				{children}
			</MetreaDialogContent>
		</MetreaDialogRoot>
	);
});

AppModal.displayName = "AppModal";
